module.exports = __webpack_public_path__ + "static/media/FL_BNoble_es.256bd22a.png";